import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/react';
import { config } from 'dotenv';
import i18n from 'i18n-react';

import {
  APIHandler,
  AppRouter,
  CookieWarning,
  DataHandler,
  locales,
  MobileWarning,
  StorageHandler,
  SweetAlert,
} from 'config/C4';
import { storageKeys } from 'config/settings';

import 'normalize.css/normalize.css';
import 'config/FontAwesome';
import 'assets/styles/styles.scss';

config();

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  });
}

const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const mobilePathRegex = /mobile/i;

const checkMobile = async (callback) =>
  callback({
    askedBefore: await StorageHandler.load('askedMobile'),
    onMobile: mobileRegex.test(window.navigator.userAgent) && !mobilePathRegex.test(window.location.pathname),
  });

const getLang = async (callback) => {
  const languageExists = await StorageHandler.exists(storageKeys.lang);
  if (languageExists) return callback((await StorageHandler.load(storageKeys.lang)) || {});

  const languageData = await APIHandler.getLanguageData();
  return callback(languageData);
};

const App = () => {
  const [languageData, setLanguageData] = useState({});
  const [texts, setTexts] = useState({});
  const [appId, setAppId] = useState(DataHandler.matchAppIdSync());
  const [{ onMobile, askedBefore }, setMobileData] = useState({});

  useEffect(() => {
    if (askedBefore === undefined) checkMobile(setMobileData);

    getLang(setLanguageData);
  }, [askedBefore]);

  useEffect(() => {
    const { langFile } = languageData;
    if (langFile && JSON.stringify(locales[langFile]) !== JSON.stringify(i18n.texts)) {
      i18n.setTexts(locales[langFile]);
      setTexts(locales[langFile]);
      StorageHandler.save(storageKeys.lang, languageData);
    }
  }, [languageData]);

  const key = JSON.stringify({ ...texts, appId });

  return (
    i18n.texts && (
      <div className="container__router">
        {!window.navigator.cookieEnabled && <CookieWarning />}

        {(onMobile === false || askedBefore === true) && appId && (
          <AppRouter
            key={key}
            onSelect={(newAppId) => {
              setAppId(newAppId);
              window.location.pathname = '/main'; // Only place where this logic can be used
            }}
          />
        )}
        {onMobile === true && askedBefore === false && (
          <SweetAlert
            trigger={onMobile === true}
            {...{
              title: i18n.translate('onMobile.header'),
              html: <MobileWarning />,
              customClass: 'mobileWarning',
              confirmButtonText: i18n.translate('onMobile.continue'),
              onClose: () => {
                setMobileData({ askedBefore: true });
                StorageHandler.save(storageKeys.askedBefore, true);
              },
            }}
          />
        )}
      </div>
    )
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
